<template>
  <div v-show="showScrollTop" @click="onScrollTop" class="scroll-to-top">
      <icon name="arrowCollapse" style="vertical-align: top;" color="#5296D6" size="30"/>
  </div>
</template>

<script>
export default {
  name: "ButtonScrollTop",
  data: () => ({
    showScrollTop: true,
  }),
  mounted() {
    document.addEventListener('scroll', this.handleScrollVisibility, true)
  },
  methods: {
    handleScrollVisibility(e) {
      const offset = 100;
      this.showScrollTop = window.scrollY > offset;
    },
    onScrollTop(e) {
      e.preventDefault();
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScrollVisibility, true)
  }
}
</script>

<style scoped lang="scss">
.scroll-to-top {
  padding: 2px;
  text-align: center;
  position: fixed;
  z-index: 10001;
  bottom: 15px;
  //display: none;
  right: 20px;
    background: #fff;
}

.scroll-to-top > i {
  display: inline-block;
  font-size: 32px;
  opacity: 0.7;
  filter: alpha(opacity=70);
}

.scroll-to-top:hover {
  cursor: pointer;
}

.scroll-to-top:hover > i {
  opacity: 1;
  filter: alpha(opacity=100);
}

@media (max-width: 991px) {
  /* 991px */
  .scroll-to-top {
    right: 10px;
  }
  .scroll-to-top > i {
    font-size: 28px;
  }
}
</style>
